import * as React from 'react'
import styled from 'styled-components'
import { device } from '../displays/devices'
// import { device } from '../displays/devices'

interface Props {
    children?: React.ReactNode
    fullwidth?: boolean
}

interface Istyle {
    isCollapsed?: boolean
    fullwidth?: boolean
}

const Wrapper = styled.div<Istyle>`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const PageWrapper = styled.div<Istyle>`
    width: 100%;

    @media (min-width: 800px) {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-top: 130px;
        transition: all 100ms;
        width: 100%;
        padding-left: ${(props) => (props.fullwidth ? '0' : '30px')};
        padding-right: ${(props) => (props.fullwidth ? '0' : '30px')};
        transition: all 500ms;
        max-width: ${(props) => (props.fullwidth ? 'none' : '1800px')};
        padding-bottom: 200px;
    }
    @media (min-width: 2000px) {
        padding-left: 0px;
        padding-right: 0px;
    }

    @media (max-width: 799px) {
        height: 100%;
    }

    @media ${device.ipad} {
        padding-top: 50px;
        padding-left: 0px;
        padding-right: 0px;
    }
    @media (min-width: 880px) and (max-width: 1200px) {
        height: 100%;
        padding-left: ${(props) => (props.fullwidth ? '0' : '30px')};
        padding-right: ${(props) => (props.fullwidth ? '0' : '30px')};
    }
    @media ${device.mobile} {
        padding-top: 50px;
    }
`

const CenteredPageWrapper: React.FunctionComponent<Props> = (props) => (
    <Wrapper>
        <PageWrapper fullwidth={props.fullwidth}>{props.children}</PageWrapper>
    </Wrapper>
)

export default CenteredPageWrapper
